/**
 * @generated SignedSource<<ca357c980b82d1a9589ea189f02e3333>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type resultListContainerArticleSearchEdge$data = ReadonlyArray<{
  readonly node: {
    readonly content: {
      readonly " $fragmentSpreads": FragmentRefs<"searchContentItemContent">;
    } | null | undefined;
    readonly id: string;
  };
  readonly " $fragmentType": "resultListContainerArticleSearchEdge";
}>;
export type resultListContainerArticleSearchEdge$key = ReadonlyArray<{
  readonly " $data"?: resultListContainerArticleSearchEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"resultListContainerArticleSearchEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "resultListContainerArticleSearchEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleSearchResultItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "searchContentItemContent"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleSearchEdge",
  "abstractKey": null
};

(node as any).hash = "54a4cb6e8dc21905b9bfe2fd67758fe9";

export default node;
